<template>
  <component :is="tag">
    <u-markdown v-if="isMarkdown" :key="visibleText">{{
      visibleText
    }}</u-markdown
    ><span
      v-else
      :class="{ 'has-white-space-prewrap': hasWhiteSpacePreWrap }"
      >{{ visibleText }}</span
    ><template v-if="canTruncate && isTruncated && !action">&hellip;</template
    ><template v-else-if="canTruncate && isTruncated">
      &hellip;<template v-if="!!action"
        ><u-link :href="href" class="has-current-color" @click="onClick">{{
          action
        }}</u-link
        >.</template
      >
    </template>
  </component>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import i18n from "@/i18n";

export default defineComponent({
  name: "UTruncate",
  props: {
    text: { type: String },
    limit: { type: Number, default: 200 },
    buffer: { type: Number, default: 20 },
    tag: { type: String, default: "span" },
    action: {
      type: [String, Boolean],
      default: () => i18n.t("_action.read_more").toString().toLocaleLowerCase()
    },
    href: { type: String, default: "javascript:void(0);" },
    hasWhiteSpacePreWrap: { type: Boolean, default: true },
    truncate: { type: Boolean, default: true },
    isMarkdown: { type: Boolean, default: false }
  },
  data: () => ({
    isTruncated: true
  }),
  computed: {
    truncatedText() {
      if (!this.text) return "";
      const text = this.text;
      const truncated = text.substr(0, text.lastIndexOf(" ", this.limit));
      if (truncated.length + this.buffer >= text.length) return text;
      return truncated.replace(/[\W]$/, "");
    },
    canTruncate(): boolean {
      if (!this.truncate) return false;
      return !!this.text && this.truncatedText.length < this.text.length;
    },
    visibleText() {
      return !!this.truncate && this.isTruncated
        ? this.truncatedText
        : this.text ?? "";
    },
    truncatedKey() {
      return btoa(this.visibleText.replaceAll(/[\W]/gi, ""));
    }
  },
  methods: {
    onClick($event: Event) {
      $event.stopPropagation();
      // If parent has .click listener – simply emit event
      if (this.$_.has(this.$listeners, "click")) {
        return this.$emit("click", $event);
      }
      // Otherwise toggle truncated text
      this.isTruncated = !this.isTruncated;
    }
  }
});
</script>
